import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7271/api';

// סוג הנחה (רשימה קבועה - תואם enum DiscountType בשרת)
export enum DiscountType {
  OneTime = 1,
  Monthly = 2,
}

export const DiscountTypeOptions: { value: DiscountType; label: string }[] = [
  { value: DiscountType.OneTime, label: 'חד-פעמי' },
  { value: DiscountType.Monthly, label: 'חודשי' },
];

// Types
export interface DiscountDto {
  id: number;
  clientId: number;
  clientName: string;
  amount: number;
  discountDate: string;
  type: number;
  typeName: string;
  endDate?: string | null;
  notes?: string;
  effectiveAmount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDiscountDto {
  clientId: number;
  amount: number;
  discountDate: string;
  type: number;
  endDate?: string | null;
  notes?: string;
}

export interface UpdateDiscountDto {
  amount: number;
  discountDate: string;
  type: number;
  endDate?: string | null;
  notes?: string;
}

export interface DiscountFilter {
  page?: number;
  pageSize?: number;
  searchTerm?: string;
  type?: number;
}

export interface DiscountPagedResult {
  items: DiscountDto[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface DiscountSummaryDto {
  totalDiscounts: number;
  clientsWithDiscountsCount: number;
  monthlyDiscountsCount: number;
  oneTimeDiscountsCount: number;
}

const BASE = `${API_BASE_URL}/discounts`;

export const discountsApi = {
  // Per-client
  getByClient: async (clientId: number): Promise<DiscountDto[]> => {
    const response = await axios.get<DiscountDto[]>(`${BASE}/client/${clientId}`);
    return response.data;
  },

  create: async (dto: CreateDiscountDto): Promise<DiscountDto> => {
    const response = await axios.post<DiscountDto>(BASE, dto);
    return response.data;
  },

  update: async (id: number, dto: UpdateDiscountDto): Promise<DiscountDto> => {
    const response = await axios.put<DiscountDto>(`${BASE}/${id}`, dto);
    return response.data;
  },

  remove: async (id: number): Promise<void> => {
    await axios.delete(`${BASE}/${id}`);
  },

  // Dashboard (מנהל מערכת)
  listAll: async (filter: DiscountFilter): Promise<DiscountPagedResult> => {
    const response = await axios.get<DiscountPagedResult>(BASE, { params: filter });
    return response.data;
  },

  getSummary: async (): Promise<DiscountSummaryDto> => {
    const response = await axios.get<DiscountSummaryDto>(`${BASE}/summary`);
    return response.data;
  },
};

// Helpers (פורמט he-IL, תואם שאר השירותים)
export const formatCurrency = (amount: number | undefined | null): string => {
  if (amount === undefined || amount === null) return '-';
  return `₪${amount.toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatDate = (dateString?: string | null): string => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric' });
};
